import styled from 'styled-components';
import sctheme from 'app/styles/sctheme';

type LayoutProps = {
  image: string;
};

export const Layout = styled.div<LayoutProps>`
  position: relative;
  min-width: 100%;
  min-height: 100%;
  overflow: hidden;
  background-color: ${sctheme.grays.$900};
  background-image: url(${props => props.image});
  background-repeat: no-repeat;
  background-position: center center;
  background-attachment: fixed;
  background-size: cover;
  padding: 0 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const AuthContainer = styled.div`
  margin: 0 auto;
  max-width: 500px;
  background-color: ${sctheme.white};
  box-shadow: 0 0 25px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  padding: 50px 50px 27px;
`;

export const ErrorContainer = styled.div`
  display: flex;
  margin: 0 auto 16px;
  max-width: 500px;
`;

export const ErrorLink = styled.span`
  a {
    color: ${sctheme.danger} !important;
    text-decoration: underline !important;
  }
`;
